module.exports = {
  title: {
    home: 'Home',
    productCenter: 'Product Center',
    applicationVideo: 'Application Video',
    aboutDongju: 'About Hangao',
    contactUs: 'Contact Us',
    downloadCenter: 'Download Center',
    cpzl: 'Product information',
    rjxz: 'Software Download',
    rjxz2: 'Download',
    qtwj: 'Other files',
    login: 'Login',
    register: 'Regist',
    search: 'search',
    more: 'more',
    online: 'consultation',
    dqkj: 'Dongqi Technology',
    factory: 'factory',
    equipment: 'equipment',
    team: 'team',
    userCenter: 'Personal',
    kfzx: 'customer service',
    zx: 'consultant',
    wxkf: 'Wechat online',
    gsjj: 'Company Profile',
    zycp: 'Main Products',
    gsry: 'Company Honor',
    c_name: 'SICHUAN DONGJU AUTOMATION TECHNOLOGY CO., LTD',
    product: 'Product Download',
    video: 'video',
    download: 'download',
    engineer: 'engineer',
    purchase: 'purchase',
    CompanyName: 'Company Name',
    address: 'address',
    contacts: 'contacts',
    phone: 'phone',
    email: 'Business Email',
    nikename: 'nikename',
    pwd: 'password',
    yyzh: 'Do you have an account',
    ljdl: 'Log in now',
    total: 'total',
    pages: 'pages',
    qg: 'National operators',
    ljcg: 'Buy now',
    cpcs: 'Product parameters',
    model: 'model',
    trip: 'trip',
    dzjd: 'Action angle',
    style: 'Style',
    show: 'Show all',
    put: 'Put it away',
    yyly: 'Application area',
    price: 'price',
    cgsl: 'number',
    xj: 'total',
    addcars: 'add to cart',
    cpjs: 'Product',
    wexz: 'Download',
    submit: 'Submit',
    xxcs: 'specification',
    cpxl: 'Product Series',
    xhsm: 'Model Description',
    shumo: '3d digital model',
    zlxz: 'Download',
    fj: 'annex',
    jj: 'Introduction',
    bbh: 'version number',
    fbsj: 'Publishing time',
    wjxz: 'file download',
    wjsm: 'File Description',
    kp: 'Billing information',
    fl:'Friendly Links',
    eemail:'Email',
    xzxh:'please select the model'
  },
  content: {
    about_hangao:'Shenzhen Henkel Automation Technology Co., Ltd. was established in 2024, specializing in the research, development, and manufacturing of electric actuators in the field of factory automation, and is capable of providing customized services to customers. The founding team of the company has 16 years of deep experience in the factory automation industry and possesses multiple innovative technologies with independent intellectual property rights. The products launched by the company are widely applied in various industrial manufacturing fields such as electronics manufacturing, biopharmaceuticals, automotive manufacturing, and rail transportation, as well as in cutting-edge research areas including aerospace, research institutions, weapon manufacturing, and nuclear industry.',
    index_about_info: 'Sichuan Dongqi Technology Co., Ltd. is located in the high tech Industrial Park of Ziyang City, Sichuan Province. It is a high-tech enterprise integrating scientific research and development, production and sales and modern service. It is also a school enterprise cooperation unit of national key vocational schools. The company has 33 CNC machine tools, more than 90 kinds of mechanical processing equipment, and more than 10 sets of claw specialized production equipment and experimental platform. The proportion of employees with college degree or above is 58%, with strong R &amp; D and production capacity.',
    index_down: 'Download',
    about_info_2: "Sichuan Dongju is committed to the standardization and modularization of hardware and software in the field of factory automation, providing one-stop systematic solutions to reduce the dependence on talents, technology and equipment in this field, save R &amp; D costs and improve the reliability of equipment. The company's main products are: electric finger, rotary platform, micro linear slide, high performance linear slide, coordinate manipulator, industrial robot, etc.",
    about_info_3: 'The company has been rated as "advanced enterprise of scientific and technological innovation" in 2016. All products on the shelves are independently developed and produced, with completely independent intellectual property rights. The products are widely used in manufacturing, scientific research, military industry and other fields.',
    us_item1_title: 'Shenzhen Henkel Automation Technology Co., Ltd.',
    us_item1_info: 'Shenzhen Henkel Automation Technology Co., Ltd. was established in 2024, specializing in the research, development, and manufacturing of electric actuators in the field of factory automation, and is capable of providing customized services to customers. The founding team of the company has 16 years of deep experience in the factory automation industry and possesses multiple innovative technologies with independent intellectual property rights. The products launched by the company are widely applied in various industrial manufacturing fields such as electronics manufacturing, biopharmaceuticals, automotive manufacturing, and rail transportation, as well as in cutting-edge research areas including aerospace, research institutions, weapon manufacturing, and nuclear industry.',
    us_item2_title:'MackAutomationLLC</br>Mark Automation Co., Ltd. (USA)',
    us_item2_info:`Mack Automation was founded in 1970 by James Frank Mack and is headquartered in Flagstaff, Arizona, USA. Mack boasts state-of-the-art equipment and a highly skilled team dedicated to getting things right the first time. The company specializes in the research, development, and manufacturing of hydraulic and pneumatic actuators, electric grippers, electric modules, and electric rotary tables. These products are widely used in industrial automation projects and are sold globally. Mack Automation takes pride in serving a customer base that includes many Fortune 500 companies. Even after more than 50 years, we continue to supply products to our very first customers, a testament to our commitment to quality, reliability, and long-term partnerships.`,
    us_item3_title:"The collaboration between Shenzhen Hankel and Mack Automation",
    us_item3_info:"After in-depth collaboration and integration between the two teams on production and management systems, Shenzhen Henkel and Mack Automation officially signed a comprehensive cooperation agreement in 2024, leading to the establishment of Shenzhen Henkel Automation Technology Co., Ltd. The production management and quality systems for the collaborative products are fully overseen by Mack Automation from the United States, while the production and assembly processes are carried out by Mack Automation's precision machinery plant. This ensures that the quality of the cooperative products consistently meets international top-tier standards."
  },
  tips: {
    r1: 'Please input your company name!',
    r2: 'Please input your address!',
    r3: 'Please input your contacts!',
    r4: 'Please input your phone number!',
    r5: 'Please input your E-mail!',
    r6: 'Please input your nickname!',
    r7: 'Please input your password!',
    r8: 'Please input right E-mail!',
    l1: 'The user name cannot be empty!',
    l2: 'Password cannot be empty!',
    a1: 'please input your detailed address',
    a2: 'please input your consignee',
    a3: 'Are you sure?',
    a4: 'Please select shipping address',
    o1: 'Note: please send the transfer record to the email address after successful payment',
    s1: 'please input the enterprise name',
    s2: 'please input the taxpayer identification number',
    s3: 'please input the enterprise address',
    s4: 'please input the Bank of deposit',
    s5: 'please input bank account number'
  },
  member: {
    gwc: 'Shopping Cart',
    cgdd: 'Purchase order',
    shdz: 'Receiving address',
    tcdl: 'Log out',
    shr: 'consignee',
    lxdh: 'contact number',
    edit: 'edit',
    confirm: 'YES',
    cancel: 'NO',
    del: 'delete',
    dgzhdk: 'Withdrawal from corporate account',
    skrhm: "payee's account name",
    yhkh: 'bank card number',
    khhh: 'account bank number',
    khyh: 'deposit bank',
    all: 'Check all',
    orderNum: 'Order number',
    qrsh: 'Confirm receipt',
    js: 'Settlement',
    yl: 'preview',
    cpname: 'Product name',
    allshop: 'All Commodities',
    ys: 'selected',
    shop: 'merchandise',
    qymc: 'enterprise name',
    ns: 'taxpayer identification number',
    qydz: 'business address',
    tjdz: 'add address',
    piece: 'piece',
    yfje: 'Amount due',
    y: 'Yuan',
    skf: 'Payee',
    xyb: 'next step',
    yzf: 'Paid'
  }
}
